import { CompassIcon } from '@atlaskit/logo';
import { Option } from 'funfix-core';
import { Map } from 'immutable';
import React from 'react';
import { makeReactContextIcon } from '../../records/Context';
import { makeErrorTranslation } from '../../records/ErrorTranslation';
import { makeAddonDiscoveryConfig, makeHostConfig } from '../../records/HostConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export default makeHostConfig({
  addonDiscovery: makeAddonDiscoveryConfig({
    featuredContentOverride: Option.empty(),
    productKey: 'compass',
    hiddenFilters: Map()
  }),
  analytics: {
    productName: 'compass',
    getSubproduct: _ => {
      /* Compass has no subproduct */
    }
  },
  errors: Map({
    AddonDefinitionNotFoundError: makeErrorTranslation({
      title: "We couldn't find the app",
      description: "It's possible the link to the app is broken."
    }),
    DescriptorFetchError: makeErrorTranslation({
      title: "We couldn't find the app",
      description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
      validationError: true
    }),
    InstallationConflictError: makeErrorTranslation({
      title: "We're seeing double!",
      description: 'The app is already installed.'
    }),
    InvalidAddonOriginError: makeErrorTranslation({
      title: "This app isn't registered",
      description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
      validationError: true
    }),
    InvalidDefinitionDetailsQueryError: makeErrorTranslation({
      title: "The URL isn't formatted correctly",
      description: 'Please enter a valid installation URL, beginning with http: or https:',
      validationError: true
    }),
    InvalidDescriptorError: makeErrorTranslation({
      title: "This app isn't working quite right",
      description: 'The app at that installation URL seems to be broken. ' + 'Please reach out to our Support team, so we can get it fixed.',
      showTID: true
    }),
    PaymentFailure: makeErrorTranslation({
      title: 'We ran into a little trouble',
      description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
      showTID: false
    }),
    default: makeErrorTranslation({
      title: 'We ran into a little trouble',
      description: 'Unfortunately, we’re unable to process your request. Please retry again in some time.',
      showTID: true
    })
  }),
  featureFlags: {
    productName: 'compass'
  },
  globalContext: Option.some({
    icon: Option.some(makeReactContextIcon(_ref => {
      let {
        label,
        size
      } = _ref;
      return /*#__PURE__*/_jsx(CompassIcon, {
        label: label,
        size: size
      });
    }))
  }),
  name: 'Compass',
  installationLocation: 'Compass',
  isCloseable: false,
  supportsManage: false
});